var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { ConfigError } from "../../util/Errors.js";
import Logger from "../../util/Logger.js";
import { FORMS } from "../ion/RemediationConstants.js";
import { CONFIGURED_FLOW } from "./constants.js";
/*!
 * Copyright (c) 2021, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function proceedIfAvailable(idxState, remediation, flow) {
  return __async(this, null, function* () {
    const rem = idxState.neededToProceed.find((item) => item.name === remediation);
    if (!rem) {
      Logger.warn("Expected remediation not found, Org may be misconfigured for this flow");
      return idxState;
    }
    try {
      const nextIdxState = yield idxState.proceed(remediation);
      return nextIdxState;
    } catch (err) {
      if (typeof err === "string" && err.startsWith("Unknown remediation choice")) {
        Logger.warn(`flow [${flow}] not valid with current Org configurations`);
        return idxState;
      } else {
        throw err;
      }
    }
  });
}
function stepIntoSpecificIdxFlow(idxState, flow = "default") {
  return __async(this, null, function* () {
    switch (flow) {
      case CONFIGURED_FLOW.DEFAULT:
      case CONFIGURED_FLOW.PROCEED:
      case CONFIGURED_FLOW.LOGIN:
        return idxState;
      // step logic is handled by auth-js
      case CONFIGURED_FLOW.REGISTRATION:
      case CONFIGURED_FLOW.RESET_PASSWORD:
        return idxState;
      case CONFIGURED_FLOW.UNLOCK_ACCOUNT:
        return yield proceedIfAvailable(idxState, FORMS.UNLOCK_ACCOUNT, flow);
      default:
        Logger.warn(`Unknown \`flow\` value: ${flow}`);
        throw new ConfigError('Invalid "flow" configuration');
    }
  });
}
function handleConfiguredFlow(originalResp, settings) {
  return __async(this, null, function* () {
    const authClient = settings.getAuthClient();
    const configuredFlow = authClient.idx.getFlow();
    const idxState = yield stepIntoSpecificIdxFlow(originalResp, configuredFlow);
    return idxState;
  });
}
export { handleConfiguredFlow };
